import React, { createContext, useContext, useMemo, useState } from 'react';
import { detectLandingLanguage, translateLanding } from '../../landing/landingLanguage';
import translations from './cvTranslations.json';

export const CV_LANGUAGE_KEY = 'cv-builder-language';
export const translateCv = (language, text, values = {}) =>
  translateLanding(language, text, translations).replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
const CvLanguageContext = createContext({ language: 'es', t: (text, values) => translateCv('es', text, values) });

export function CvLanguageProvider({ children }) {
  const [language, updateLanguage] = useState(() => {
    try {
      const saved = localStorage.getItem(CV_LANGUAGE_KEY);
      if (['es', 'en', 'pt'].includes(saved)) return saved;
    } catch { /* Language selection also works without browser storage. */ }
    return detectLandingLanguage();
  });
  const value = useMemo(() => ({
    language,
    t: (text, values) => translateCv(language, text, values),
    setLanguage: next => {
      if (!['es', 'en', 'pt'].includes(next)) return;
      updateLanguage(next);
      try { localStorage.setItem(CV_LANGUAGE_KEY, next); } catch { /* Keep the in-memory preference. */ }
    },
  }), [language]);
  return <CvLanguageContext.Provider value={value}>{children}</CvLanguageContext.Provider>;
}

export const useCvLanguage = () => useContext(CvLanguageContext);
